import React from 'react';
import { FormValues } from '@wix/form-viewer';

export type FormComponentContextType = {
  wixFormValues: FormValues;
  // One entry per participant when collecting a form per participant; a single-item
  // list mirroring wixFormValues otherwise. Used by the submit flow to create one
  // booking per participant.
  participantFormValues: FormValues[];
  isCartConflictError?: boolean;
  isUpsellPluginInstalled?: boolean;
  dateRegionalSettingsLocale: string;
};

const FormComponentContext = React.createContext<FormComponentContextType>(
  {} as FormComponentContextType,
);
export const FormComponentContextProvider = FormComponentContext.Provider;

export const useFormComponentContext = () =>
  React.useContext(FormComponentContext);
